module.exports = __webpack_public_path__ + "static/media/aprobar.eaba68d2.png";